import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import {
  collection,
  connectFirestoreEmulator,
  doc,
  getDoc,
  getDocs,
  getFirestore,
} from "firebase/firestore";
import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const auth = getAuth();
export const firestore = getFirestore();
export const functions = getFunctions();
export const storage = getStorage();
export const db = getFirestore(app);
export const realtimeDb = getDatabase(app);

if (process.env.NODE_ENV === "development") {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(firestore, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  // connectStorageEmulator(storage, "127.0.0.1", 9199); Doesn't work with Airtable
  connectDatabaseEmulator(realtimeDb, "127.0.0.1", 9000);
}

export const userSetPassword = httpsCallable(functions, "user-setPassword");

export async function getActivation(userId) {
  const docRef = doc(db, "activations", userId);
  const docSnap = await getDoc(docRef);

  if (!docSnap.exists()) {
    return { error: "not-found" };
  }

  console.log("Activation document:", docSnap.data());
  return docSnap.data();
}

export async function getPractices(user) {
  const docRef = doc(db, "users", user.uid);
  const docSnap = await getDoc(docRef);

  if (!docSnap.exists()) {
    throw new Error("User not found");
  }

  // Get practices
  const querySnapshot = await getDocs(
    collection(db, "users", user.uid, "practices")
  );
  return querySnapshot.docs.map((doc) => doc.data());
}
